import { FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";

const FloatingWhatsApp = () => (
  <motion.a
    href="https://wa.me/923151644222"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1, type: "spring", stiffness: 200 }}
    className="fixed bottom-6 right-6 z-[60] grid h-14 w-14 place-items-center rounded-full bg-gradient-to-br from-brand-green to-[#1f8a0c] text-white text-2xl shadow-[0_10px_30px_rgba(76,175,24,0.55)] hover:scale-110 transition-transform"
  >
    <span className="absolute inset-0 rounded-full bg-brand-green/60 animate-ping" />
    <FaWhatsapp className="relative" />
  </motion.a>
);

export default FloatingWhatsApp;
